// this file is automatically generated by version_generate.ts script
      export const gitInfo = {
          version: 'v4.0.0',
      };